'use client';

// Grid das integrações (recolhível): 3 linhas + fade na 4ª (peek ~40%) + botão
// "Ver mais" em liquid glass (igual ao "Ver como funciona" da hero). Cards e grid
// idênticos ao da página; só adiciona o efeito de expandir.

import Image from 'next/image';
import { useState } from 'react';

const INTEGRATIONS: { slug: string; name: string }[] = [
  { slug: 'hotmart', name: 'Hotmart' },
  { slug: 'kiwify', name: 'Kiwify' },
  { slug: 'cakto', name: 'Cakto' },
  { slug: 'eduzz', name: 'Eduzz' },
  { slug: 'kirvano', name: 'Kirvano' },
  { slug: 'hubla', name: 'Hubla' },
  { slug: 'perfectpay', name: 'Perfect Pay' },
  { slug: 'lastlink', name: 'Lastlink' },
  { slug: 'ticto', name: 'Ticto' },
  { slug: 'lowify', name: 'Lowify' },
  { slug: 'ggcheckout', name: 'GGCheckout' },
  { slug: 'stripe', name: 'Stripe' },
  { slug: 'shopify', name: 'Shopify' },
  { slug: 'woocommerce', name: 'WooCommerce' },
  { slug: 'yampi', name: 'Yampi' },
  { slug: 'greenn', name: 'Greenn' },
  { slug: 'cartpanda', name: 'Cartpanda' },
  { slug: 'braip', name: 'Braip' },
  { slug: 'pepper', name: 'Pepper' },
  { slug: 'monetizze', name: 'Monetizze' },
  { slug: 'systeme', name: 'Systeme.io' },
  { slug: 'digitalmanagerguru', name: 'Digital Manager Guru' },
  { slug: 'vega-checkout', name: 'Vega Checkout' },
];

export function IntegrationsGridExpandable() {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div className="mt-12 md:mt-14">
        {/* Recolhido = 3 linhas + 40% da 4ª. Card tem altura fixa (88/92), então a
            altura da linha não varia com as colunas: um max-height por breakpoint basta.
            O fade é uma mask-image (desbota os próprios cards até transparente), pra deixar
            o fundo real da página aparecer sem faixa de cor sólida. */}
        <div
          className={`grid grid-cols-2 gap-3.5 overflow-hidden pt-1 transition-[max-height] duration-700 ease-[cubic-bezier(0.22,0.61,0.36,1)] motion-reduce:transition-none sm:grid-cols-3 md:grid-cols-5 ${
            expanded
              ? 'max-h-[2000px]'
              : 'max-h-[345px] [mask-image:linear-gradient(to_bottom,#000_60%,transparent_98%)] [-webkit-mask-image:linear-gradient(to_bottom,#000_60%,transparent_98%)] md:max-h-[360px]'
          }`}
        >
          {INTEGRATIONS.map((it) => (
            <div
              key={it.slug}
              className="border-border-subtle hover:border-violet/40 flex h-[88px] items-center justify-center rounded-2xl border bg-[linear-gradient(180deg,rgba(255,255,255,0.03),rgba(255,255,255,0.01))] transition hover:-translate-y-0.5 md:h-[92px]"
            >
              <Image
                src={`/icons-integrations/${it.slug}.svg`}
                alt={it.name}
                width={120}
                height={34}
                className="max-h-[32px] w-auto max-w-[72%] object-contain"
              />
            </div>
          ))}
        </div>
      </div>

      <div className={`relative z-10 flex justify-center ${expanded ? 'mt-6' : '-mt-6'}`}>
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
          className="text-ink inline-flex min-h-[44px] items-center justify-center rounded-full border border-[rgba(222,219,246,0.16)] bg-[linear-gradient(180deg,rgba(40,34,64,0.55),rgba(24,20,38,0.42))] px-8 py-3 text-base font-medium shadow-[0_10px_40px_rgba(0,0,0,0.5),inset_0_1px_0_rgba(255,255,255,0.22),inset_0_-1px_0_rgba(0,0,0,0.25)] backdrop-blur-xl backdrop-saturate-150 transition hover:border-[rgba(222,219,246,0.28)]"
        >
          {expanded ? 'Ver menos' : 'Ver mais'}
        </button>
      </div>
    </>
  );
}
